
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { SelectValue, Tooltip } from 'tdesign-react';

import { SelectDown } from '@/components/icon';
import { CompletionTipType, CompletionTipValue } from '@/interface';

import styles from './index.module.less';

export const endAndMoreOptions = [{
  label: '未完待续',
  value: CompletionTipValue[CompletionTipType.COMPLETIONTYPE_TOBECONTINUED],
  enum: CompletionTipType.COMPLETIONTYPE_TOBECONTINUED,
}, {
  label: '大结局',
  value: CompletionTipValue[CompletionTipType.COMPLETIONTYPE_END],
  enum: CompletionTipType.COMPLETIONTYPE_END,
}];

export const BranchSelect: React.FC<{
  options: { label: string, value: string }[];
  onChange: (value: { label: string, value: string }) => void;
  value?: SelectValue;
  multiple?: boolean;
  end?: boolean;
  disabled?: boolean;
}> = (props) => {
  const { value, onChange, options = [], end, disabled } = props;

  const handleChange = (val: { label: string, value: string }) => {
    if (disabled) {
      return;
    }
    onChange(val);
    setVisible(false);
  };

  const label = [...endAndMoreOptions, ...options].filter(e => e.value === value)?.[0]?.label;

  const [visible, setVisible] = useState(false);

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (disabled) {
      return;
    }
    setVisible(!visible);
  };

  useEffect(() => {
    document.addEventListener('click', handleWindowClick);
    return () => {
      document.removeEventListener('click', handleWindowClick);
    };
  }, []);

  const handleWindowClick = () => {
    setVisible(false);
  };

  const handleClickContent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div >
      <Tooltip
        placement='bottom'
        overlayClassName={styles.tooltip}
        content={
          <div className={styles.content} onClick={handleClickContent} >
            <div className={classNames(styles.main, { [styles.MaxHeight]: options?.length })} >
              {options.map((option, idx) => (
                <div
                  className={classNames(styles.item, { [styles.active]: option.value === value })}
                  key={idx} onClick={() => handleChange(option)}
                >
                  <div className={styles.labelAlign}>
                    <div>{option.label}</div>
                  </div>
                </div>
              ))}
            </div>
            {
              end ? <div className={styles.footer}>
                {
                  endAndMoreOptions.map((option, idx) => (
                    <div
                      className={classNames(styles.item, { [styles.active]: option.value === value })}
                      key={idx}
                      onClick={() => handleChange(option)}
                    >
                      <div className={styles.labelAlign}>
                        <div>{option.label}</div>
                      </div>
                    </div>
                  ))
                }
              </div>
                : null
            }
          </div>
        }
        showArrow={false}
        visible={visible}
      >
        <div className={styles.show} onClick={handleOpen}>
          <div className={styles.label}>
            <div className={styles.labelAlign}>
              <div>{label}</div>
            </div></div>
          <SelectDown />
        </div>
      </Tooltip>
      {!value ? (
        <span
          className={classNames(styles.errors, 'nova-text-error')}
        >
          请补充选项
        </span>
      ) : null}
    </div>
  );
};
